<div class="overlay-wrapper" *ngIf="isLoading">
    <p-progressSpinner></p-progressSpinner>
</div>

<main id="content" role="main" class="main">

    <div class="content container">
        <div >
        </div>
        <div class="row" >


            <div *ngIf="mainPath === 'Investment'" class="col-lg-4 mb-3 mb-lg-5">

                <div class="card h-100">

                    <div class="card-header card-header-content-between">
                        <h3 class="card-header-title fw-normal">{{'Companies'|translate}}</h3>

                        <div class="dropdown">
                            <a class="btn btn-white btn-sm" href="/Form?BluePrintId=656b77df4625a11c010e3548&SectionId=64f0e1dc666ecc198cf6cbed"><i class="bi-plus-lg"></i> 
                                {{'addCompnay'|translate}}
                            </a>
                        </div>

                    </div>


                    <div class="card-body">


                        <ng-container *ngIf="companyLoading">
                            <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
    
                        </ng-container>

                        <ng-container  *ngIf="!companyLoading">
                            <p>{{'addCompDesc'|translate}}</p>
                            <ul class="list-group list-group-flush list-group-no-gutters">
    
                                <li class="list-group-item" *ngFor="let item of compaines">
                                    <div class="d-flex">
                                        <div class="flex-shrink-0">
                                            <span class="avatar avatar-success avatar-circle">
                                                <span class="avatar-initials fw-normal">{{'active'|translate}}</span>
                                            </span>
                                        </div>
                                        <div class="flex-grow-1 me-3 ms-3" >
                                            <div class="row align-items-center">
                                                <div class="col" >
                                                    <h5 class="mb-0"> {{item?.value}}</h5>
                                                    <!-- <span class="d-block fs-6 text-body">ذات مسؤولية محدودة</span> -->
                                                </div>
    
                                                <div class="col-auto">
                                                    <a class="btn fw-bold btn-primary btn-sm"
                                                        routerLink="/{{mainPath}}/CompanyInfo" [queryParams]="{'id':item?.key}">{{'view'|translate}} <i
                                                            class="bi-box-arrow-up-left ms-1"></i></a>
                                                </div>
    
                                            </div>
    
                                        </div>
                                    </div>
                                </li>
    
                            </ul>
                        </ng-container>
                        
                    </div>

                </div>

            </div>

            <div [ngClass]="{'col-lg-8': mainPath === 'Investment', 'col-lg-12': mainPath !== 'Investment'}" class=" mb-3 mb-lg-5">
                <div class="card h-100">

                    <div class="card-header card-header-content-between">
                        <h3 class="card-header-title fw-normal">{{'latestRequest'|translate}} </h3>

                        <div class="dropdown">
                            <a class="btn btn-white btn-sm" routerLink="/Sections" [queryParams]="{SectionId:SectionId}"><i
                                    class="bi-plus-lg"></i> {{'applyRequest'|translate}}</a>
                        </div>

                    </div>

                    <div class="tabs-wrapper">
                        <ul class="nav-tabs justify-content-center pb-2">
                          <li class="nav-item tab is-active" data-role="tab" data-target="#tabs-home3" (click)="runFillCurrentServicesForConsumer()">
                            {{'uncompleteRequest'|translate}}
                          </li>
                      
                          <li class="nav-item tab" data-role="tab" data-target="#tabs-profile3" (click)="fillArchiveServicesForConsumer()">
                            {{'completeRequest'|translate}}
                          </li>
        
                        </ul>
                      
                        <div class="tab-content">
                          <div class="tab-panel is-active" id="tabs-home3">
                            
                            <div class="card-body card-body-height p-0">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead class="thead-light">
                                            <tr class="text-center">
                                                <th class="fs-5">{{'applicationNumber'|translate}}</th>
                                                <th class="fs-5">{{'applicationType'|translate}}</th>
                                                <th class="fs-5">{{'status'|translate}}</th>
                                                <th class="fs-5">{{'applyDate'|translate}}</th>
                                                <th class="fs-5"></th>
                                            </tr>
                                        </thead>
                                        <tbody class="text-center">

                                            
                                            <tr class="" *ngFor="let item of currentServices">
                                                <td class="order-md-1">
                                                    <span class="mb-0">{{item?.applicationNumber}}</span>
                                                </td>
                                                <td class="order-md-2">
                                                    <h5 style="white-space: pre-line;width: 100px; ">
                                                        {{item?.name}}
                                                    </h5>
                                                </td>
                                                <td class="order-md-3">
                                                    <span style="white-space: pre-line;width: 100px; " class="badge bg-soft-warning text-warning rounded-pill fs-5">
                                                        {{item?.status}}
                                                    </span>
                                                </td>
                                                <td class="order-md-4">
                                                    <span>
                                                        {{item?.createdDate|date:'dd/MM/yyyy'}}
                                                     </span>
                                                </td>
                                                <td class="order-md-4">

                                                    <a class="btn btn-white btn-sm py-1 px-4  my-2" href="/Form?serviceId={{item?.id}}&showForm=true&serviceType=CURRENT">{{'viewForm'|translate}}</a>

                                                    <br>

                                                    <a class="btn btn-white btn-sm py-1 px-4  my-2" href="/{{mainPath}}/ServiceOutput?serviceId={{item?.id}}&serviceType=CURRENT">{{'output'|translate}}</a>

                                                    <br>
        
        
                                                    <ng-container *ngIf="item.yourTurn==true" >
                                                        <a class="btn btn-white btn-sm py-1 px-4"
                                                            routerLink="/Form" [queryParams]="{serviceId:item?.id,serviceName:item?.name}">{{'completeRequestFrom'|translate}}</a>
        
                                                    </ng-container>
        
                                                </td>
                                            </tr>

                                            <tr *ngFor="let item of oldCurrentServices">
                                                <td class="order-md-1">
                                                    <span>
                                                        {{item?.id}}
                                                    </span>
                                                </td>
                                                <td class="order-md-2">
                                                    <h5 style="white-space: pre-line;width: 100px; ">
                                                        
                                                        {{item?.title}}
                                                    </h5>
                                                </td>
                                                <td class="order-md-3">
                                                    <span style="white-space: pre-line;width: 100px; " class="badge bg-soft-warning text-warning rounded-pill fs-5">
                                                        {{item?.status_ar}}
                                                    </span>
                                                </td>
                                                <td class="order-md-4">
                                                    <span style="white-space: pre-line;width: 100px; ">
                                                        {{item?.created_at}}
                                                    </span>
                                                </td>
                                                <td class="order-md-4">
                                                    <a class="btn btn-white btn-sm py-1 px-4  my-2" (click)="openOldApplicant(item.id)" >{{'viewForm'|translate}}</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                          </div>
                          <div class="tab-panel" id="tabs-profile3">
                            
                            <div class="card-body card-body-height p-0">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead class="thead-light">
                                            <tr class="text-center">
                                                <th class="fs-5">{{'applicationNumber'|translate}}</th>
                                                <th class="fs-5">{{'applicationType'|translate}}</th>
                                                <th class="fs-5">{{'status'|translate}}</th>
                                                <th class="fs-5">{{'applyDate'|translate}}</th>
                                                <th class="fs-5"></th>
                                            </tr>
                                        </thead>
                                        <tbody class="text-center">
                                            <tr class="justify-content-center align-middle" *ngFor="let item of archiveService">
                                                <td class="order-md-1">
                                                    <span class="mb-0">{{item?.applicationNumber}}</span>
                                                </td>
                                                <td class="order-md-2">
                                                    <h5 style="white-space: pre-line;width: 100px; ">
                                                        {{item?.name}}
                                                    </h5>
                                                </td>
                                                <td class="order-md-3">
                                                    <span style="white-space: pre-line;width: 100px; " [ngClass]="item.typeStatus==2?'bg-soft-danger text-danger':'bg-soft-success text-success'" class="badge rounded-pill fs-5">
                                                        {{item?.status}}
                                                    </span>
                                                </td>
                                                <td class="order-md-4">
                                                    <span >
                                                        {{item?.createdDate|date:"dd/MM/yyyy"}}
                                                     </span>
                                                </td>
                                                <td class="order-md-4">

                                                    <a class="btn btn-white btn-sm py-1 px-4 my-2" href="/Form?serviceId={{item?.id}}&showForm=true&serviceType=ARCHIVED">{{'viewForm'|translate}}</a>
        
                                                    <br>

                                                    <a class="btn btn-white btn-sm py-1 px-4 my-2" href="/{{mainPath}}/ServiceOutput?serviceId={{item?.id}}&serviceType=ARCHIVED">{{'output'|translate}}</a>
        
                                                    <br>

                                                    <span *ngIf="item.typeStatus==2">
                                                        <i class="fa fa-eye text-primary" role="button" (click)="showRejectedType(item.id)"></i>
                                                    </span>
        
                                                </td>
                                            </tr>

                                            <tr *ngFor="let item of oldArchiveService">
                                                <td class="order-md-1">
                                                    <span>
                                                        {{item.id}}
                                                    </span>
                                                </td>
                                                <td class="order-md-2">
                                                    <h5 style="white-space: pre-line;width: 100px; ">
                                                        {{item?.title}}
                                                    </h5>
                                                </td>
                                                <td class="order-md-3">
                                                    <span style="white-space: pre-line;width: 100px; " class="badge bg-soft-warning text-warning rounded-pill fs-5">
                                                        {{item?.status_ar}}
                                                    </span>
                                                </td>
                                                <td class="order-md-4">
                                                    <span style="white-space: pre-line;width: 100px; " >
                                                        {{item?.created_at}}
                                                    </span>
                                                </td>
                                                <td class="order-md-4">
                                                    <a class="btn btn-white btn-sm py-1 px-4  my-2" (click)="openOldApplicant(item.id)" >{{'viewForm'|translate}}</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                          </div>
        
                        </div>
                      
                      </div>


                  

                </div>
            </div>

        </div>
    </div>

</main>

